import CTLNotificationBooleanCell from "application/components/CTLNotificationBooleanCell";
import CTLSelectCell from "application/components/CTLSelectCell";
import DefaultCell from "application/components/DefaultCell";
import CTLLocationBackgroundImageCell from "application/components/CTLLocationBackgroundImageCell";
import RowAction from "application/components/RowAction";
import { nmsMenus } from "globals/configuration/nms";
import formControl from "globals/form-control";
import { column } from "stylis";

const Attributes = {
  formSize: "md",
  columns: 3,
  enableAddButton: true,
  modes: nmsMenus.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
  messages: {
    success: "Updated successfully",
    error: "Unable to update data",
  },
  settingsMode: false,
};

const operationURLS = {
  list: "location/list",
  update: "location/update",
  create: "location/create",
  delete: "location/delete/",
  uploadBackgroundImage: "location/background/upload",
};

const getColumns = (onDelete, onEdit, onUploadStateChange) => {
  return [
    {
      Header: "Background Image URL",
      accessor: "backgroundImageURL",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      controlType: "imageUpload",
      uploadUrl: operationURLS.uploadBackgroundImage,
      onUploadStateChange,
      Cell: ({ value }) => <CTLLocationBackgroundImageCell value={value} />,
      width: 6,
      groupHeading: "Location",
    },
    {
      Header: "Location Code",
      accessor: "code",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      disabled: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      validation: formControl.string().required("Location Code Is Required"),
      width: 6,
      groupHeading: "Location",
    },
    {
      Header: "Location Name",
      accessor: "name",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      validation: formControl.string().required("Location Code Is Required"),
      width: 6,
      groupHeading: "Location",
    },
    {
      Header: "Parent Location",
      accessor: "parentLocation",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "select",
      Cell: ({ value }) => <CTLSelectCell value={value} columns={column} />,
      width: 6,
      groupHeading: "location",
      options: {
        keyField: "locationId",
        keyDescription: "locationName",
        values: [],
        url: "location/dropdown/list",
      },
    },

    {
      Header: "X Coordinate",
      accessor: "xcoordinate",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
      groupHeading: "Location",
    },
    {
      Header: "Y Coordinate",
      accessor: "ycoordinate",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
      groupHeading: "Location",
    },
    {
      Header: "Disable Notification",
      accessor: "disableNotification",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      Cell: ({ value }) => <CTLNotificationBooleanCell value={value} />,
      dataType: "boolean",
      controlType: "boolean",
      groupHeading: "Location",
      width: 6,
    },
    {
      Header: "Level 0 Mail Id",
      accessor: "escalationLevel0MailId",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level0 Sms Number",
      accessor: "escalationLevel0SmsId",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level 1 Duration",
      accessor: "escalationLevel1Duration",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
      dataType: "integer",
    },
    {
      Header: "Level 1 Mail Id",
      accessor: "escalationLevel1MailId",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level 1 Sms Number",
      accessor: "escalationLevel1SmsId",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level 2 Duration",
      accessor: "escalationLevel2Duration",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
      dataType: "integer",
    },
    {
      Header: "Level 2 Mail Id",
      accessor: "escalationLevel2MailId",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level 2 Sms Number",
      accessor: "escalationLevel2SmsId",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level 3 Duration",
      accessor: "escalationLevel3Duration",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "integer",
      width: 6,
    },
    {
      Header: "Level 3 Mail Id",
      accessor: "escalationLevel3MailId",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level 3 Sms Number",
      accessor: "escalationLevel3SmsId",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };
